<div class="mb-25">
    <!-- Breadcrumb removed but spacing maintained -->
</div>

<!-- Settings -->
<mat-card
    class="daxa-card settings-card mb-25 border-radius bg-white border-none d-block"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-content>
        <ul class="pl-0 mt-0 list-unstyled">
            <li class="d-inline-block">
                <a routerLink="/settings" mat-button routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    Postavke korisničkog računa
                </a>
            </li>
            <li class="d-inline-block">
                <a routerLink="/settings/change-password" mat-button routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    Promjena lozinke
                </a>
            </li>
            <!-- <li class="d-inline-block">
                <a routerLink="/settings/privacy-policy" mat-button routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    Privatnost i GDPR
                </a>
            </li>
            <li class="d-inline-block">
                <a routerLink="/settings/terms-conditions" mat-button routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    Uvjeti korištenja
                </a>
            </li> -->
        </ul>
        <router-outlet />
    </mat-card-content>
</mat-card>